import React from "react";
import ApiData from "../../api/ApiData";
import { ItemAllReport } from "./ItemAllReport";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import Loader from "../Loader";
import { ContainerSubTitleGrey } from "../ContainerSubTitleGrey";

const GRID_CLASS = "cc-v4-soft-grid reports-subscription-grid";

export const ListAllReport = observer(({ data, companys }) => {
  const navigate = useNavigate();
  const toCompany = async (e) => {
    try {
      ApiData.setParametersCompany("inn", e.company_rel.inn);
      navigate(`/company/${ApiData.company.company.inn}`);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="cc-v4-soft-list-root">
      <div className={`cc-v4-soft-header ${GRID_CLASS}`}>
        <span className="cc-v4-soft-th-static">
          <span className="cc-v4-soft-th-label">Компания</span>
        </span>
        <span className="cc-v4-soft-th-static">
          <span className="cc-v4-soft-th-label">ИНН</span>
        </span>
        <span className="cc-v4-soft-th-static">
          <span className="cc-v4-soft-th-label">Ответственный менеджер</span>
        </span>
        <span className="cc-v4-soft-th-static">
          <span className="cc-v4-soft-th-label">Менеджер сопровождения</span>
        </span>
        <span className="cc-v4-soft-th-static reports-th-numeric">
          <span className="cc-v4-soft-th-label">Дней</span>
        </span>
        <span className="cc-v4-soft-th-static reports-th-numeric">
          <span className="cc-v4-soft-th-label">До</span>
        </span>
      </div>
      <div className="cc-v4-soft-body">
        {!ApiData.observableReportLic ? (
          <>
            {data !== null && data.length > 0 ? (
              data.map((lic) => (
                <ItemAllReport
                  toCompany={toCompany}
                  lic={lic}
                  key={lic.id}
                  gridClass={GRID_CLASS}
                  companys={companys}
                />
              ))
            ) : (
              <ContainerSubTitleGrey text="Нет подписок по заданному фильтру" />
            )}
          </>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
});
